export default __webpack_public_path__ + "static/media/ucl.1a51ab50.jpeg";